import { lazy } from 'react';
export var GroupEditPageAsync = lazy(function () { return import('./GroupEditPage'); });
